import clsx from 'clsx'
import React from 'react'

import {classes} from './styles'

type Props = {
  fullHeight?: boolean
  className?: string
}

const DrawerSection: React.FC<React.PropsWithChildren<Props>> = ({fullHeight, children, className}) => {
  return <div className={clsx(classes.section, fullHeight && classes.fullHeight, className)}>{children}</div>
}

export default DrawerSection
